import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (commentObj) => {
  return await ctx.put(
    `/specialty_list/comments/${commentObj.list_uuid}`,
    commentObj
  );
};
